import { createSlice } from "@reduxjs/toolkit";
import * as Actions from "../actions";
import { dataTelasReducer } from "../reducers";
import { InitialStateTelas } from "./models";

const initialState: InitialStateTelas = {
  items: [],
  dialogForm: {
    open: false,
    content: {
      mode: "",
      values: null,
    },
  },
  requestGetParams: {},
  pagination: {
    page: 1,
    rowsPerPage: 15,
    totalPages: 0,
    totalItems: 0,
  },
};

const telasSlice = createSlice({
  name: "acessosApp/telas",
  initialState,
  reducers: {
    openDialogForm: (state, action) => {
      state.dialogForm.open = true;
      state.dialogForm.content = action.payload;
    },
    closeDialogForm: (state) => {
      state.dialogForm.open = false;
      state.dialogForm.content = {
        mode: "",
        values: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(Actions.getTelas.fulfilled, dataTelasReducer);
  },
});

export const { openDialogForm, closeDialogForm } = telasSlice.actions;

export default telasSlice.reducer;
